import { Box, Chip, FormControlLabel, Switch } from '@hermes/web-components'
import React from 'react'

type ToggleProps = {
  toggled: boolean
  setToggled: (arg: boolean) => void
  toggleTitle?: string
  children: React.ReactNode
  infoProps?: {
    title: string
    action?: () => void
  }
}

export const ToggleWithControl = ({ children, infoProps, toggled, setToggled, toggleTitle }: ToggleProps) => (
  <Box display="flex" justifyContent="space-between" sx={{ padding: '20px', paddingLeft: 0 }}>
    <FormControlLabel
      control={<Switch size="small" checked={toggled} onChange={() => setToggled(!toggled)} />}
      label={toggleTitle}
      sx={{ marginLeft: 0, gap: 1 }}
      disableTypography
    />
    {children}
    {infoProps && (
      <Chip
        disabled={!infoProps.action}
        label={infoProps.title}
        color="info"
        sx={{ marginLeft: 1 }}
        onClick={infoProps.action}
      />
    )}
  </Box>
)
